import React, { useEffect, useState } from "react";
import Stepper from "../../ui/Stepper";
import {
  STEPPER_LIST_COUNTRY,
  COST_OF_LIVING_TYPE,
} from "../../../../constants/cms";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCountryBasicDetail,
  clearCountryBasicDetail,
  putCountryBasicDetail,
} from "../../../../../store/slices/country";
import { useDispatch, useSelector } from "react-redux";
import BasicDetailForm from "./basicDetailForm";
const BasicDetail = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [saveAndNext, setSaveAndNext] = useState(false);
  const user = useSelector((state) => state?.userData?.user?.data);
  const userPermission = useSelector(
    (state) => state.userData?.userPermission?.data
  );
  const [initialValues, setInitialValues] = useState({});
  const dispatch = useDispatch();
  const { countryBasicDetailData, putCountryBasicDetailData } = useSelector(
    (state) => state.cmsCountry
  );
  useEffect(() => {
    if (id) {
      dispatch(getCountryBasicDetail({ country_id: id }));
    }
    return () => {
      dispatch(clearCountryBasicDetail());
    };
  }, [id]);

  useEffect(() => {
    if (putCountryBasicDetailData) {
      if (saveAndNext) {
        navigate(
          `/cms/country/${putCountryBasicDetailData?.country_id}/content-detail`
        );
      }else{
        dispatch(getCountryBasicDetail({ country_id: id }));
      }
      setSaveAndNext(false);
    }
  }, [putCountryBasicDetailData]);

  useEffect(() => {
    if (countryBasicDetailData) {
      let newvalues = {
        population: countryBasicDetailData.country_data?.population
          ? countryBasicDetailData.country_data?.population
          : null,
        gdp: countryBasicDetailData.country_data?.gdp
          ? countryBasicDetailData.country_data?.gdp
          : null,
        employment_rate: countryBasicDetailData.country_data?.employment_rate
          ? countryBasicDetailData.country_data?.employment_rate
          : null,
        crime_rate: countryBasicDetailData.country_data?.crime_rate
          ? countryBasicDetailData.country_data?.crime_rate
          : null,
        literacy_rate: countryBasicDetailData.country_data?.literacy_rate
          ? countryBasicDetailData.country_data?.literacy_rate
          : null,
        country_living_costs:
          countryBasicDetailData.country_living_costs.length > 0
            ? countryBasicDetailData.country_living_costs
            : [{ cost_type: null, min_cost: "", max_cost: "" }],
        updated_by: countryBasicDetailData.updated_by,
        last_updated: countryBasicDetailData.last_updated,
      };

      setInitialValues(newvalues);
    }
  }, [countryBasicDetailData]);

  const submit = (values) => {
    let data = {};
    data.population = values?.population === "" ? null : values?.population;
    data.gdp = values?.gdp;
    data.employment_rate = values?.employment_rate;
    data.crime_rate = values?.crime_rate;
    data.literacy_rate = values?.literacy_rate;
    data.country_living_costs = values?.country_living_costs;
    data.updated_by = user?.id;
    dispatch(putCountryBasicDetail({ country_id: id }, data));
  };

  return (
    <div>
      <div className={"mt50"}>
        <div className={`${"stepper"} ${"examviewlist"}`}>
          <Stepper data={STEPPER_LIST_COUNTRY} activeStep={1} />
        </div>
      </div>
      <div>
        {id && (
          <BasicDetailForm
            submit={(e) => submit(e)}
            initialValues={initialValues}
            setSaveAndNext={setSaveAndNext}
            userPermission={userPermission}
            costOfLivingOptions={COST_OF_LIVING_TYPE}
          />
        )}
      </div>
    </div>
  );
};

export default BasicDetail;
